// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2hqwD","selected":"Chip_selected__8aalB"};